import { Colors } from "../../config/DesignConstants";
import BaseEntity from "../../core/entity/BaseEntity";
import { createGraphics, GameGraphics } from "../../core/entity/GameSprite";
import { V2d } from "../../core/Vector";

const MARGIN = 10;
const INDICATOR_LENGTH = 30;

export default class OffScreenIndicator extends BaseEntity {
  sprite: GameGraphics;

  constructor() {
    super();
    this.sprite = createGraphics("ui");
  }

  onTick(dt: number) {
    this.sprite.clear();

    const camera = this.game!.camera;
    const screenSize = camera.getViewportSize();
    const screenCenter = new V2d(screenSize.x / 2, screenSize.y / 2);

    const levelEntities = this.game!.entities.getTagged("levelEntity");

    for (const entity of levelEntities) {
      // Cast to BaseEntity to access getPosition
      const baseEntity = entity as BaseEntity;
      if (!baseEntity.sprite && !baseEntity.body) {
        continue; // Skip entities without position
      }

      const worldPos = baseEntity.getPosition();

      if (!worldPos || camera.worldPointIsVisible(worldPos)) {
        continue;
      }

      const screenPos = camera.toScreen(worldPos);
      const direction = screenPos.sub(screenCenter).normalize();

      const edgePos = this.calculateEdgePosition(
        screenPos,
        screenCenter,
        screenSize,
      );
      this.drawIndicator(edgePos, direction);
    }
  }

  private calculateEdgePosition(
    targetPos: V2d,
    center: V2d,
    screenSize: V2d,
  ): V2d {
    const direction = targetPos.sub(center);
    const halfWidth = screenSize.x / 2;
    const halfHeight = screenSize.y / 2;

    const scaleX =
      Math.abs(direction.x) > 0 ? halfWidth / Math.abs(direction.x) : Infinity;
    const scaleY =
      Math.abs(direction.y) > 0 ? halfHeight / Math.abs(direction.y) : Infinity;
    const scale = Math.min(scaleX, scaleY);

    return center.add(direction.mul(scale));
  }

  private drawIndicator(edgePosition: V2d, direction: V2d): void {
    const base = edgePosition.sub(direction.mul(MARGIN));
    const tip = edgePosition.add(direction.mul(INDICATOR_LENGTH));
    this.sprite.moveTo(base.x, base.y);
    this.sprite.lineTo(tip.x, tip.y);
    this.sprite.stroke({ color: Colors.RED, width: 2 });
  }
}
